@switch (parameterField().type) {
    @case (ReportScheduleDialogParameterFieldTypeEnum.NumberParameter) {
        <mat-form-field class="w-100">
            <mat-label>{{ parameterField().promptText ?? parameterField().name }}</mat-label>
            <input [(ngModel)]="value" type="number" matInput [required]="required()" />
        </mat-form-field>
    }
    @case (ReportScheduleDialogParameterFieldTypeEnum.CurrencyParameter) {
        <mat-form-field class="w-100">
            <mat-label>{{ parameterField().promptText ?? parameterField().name }}</mat-label>
            <input [(ngModel)]="value" type="number" matInput [required]="required()" />
        </mat-form-field>
    }
    @case (ReportScheduleDialogParameterFieldTypeEnum.BooleanParameter) {
        <mat-checkbox [(ngModel)]="value" class="w-100" [required]="required()">
            {{ parameterField().promptText ?? parameterField().name }}
        </mat-checkbox>
    }
    @case (ReportScheduleDialogParameterFieldTypeEnum.DateParameter) {
        <sl-relative-date-input
            [(ngModel)]="value"
            class="w-100"
            [labelKey]="parameterField().promptText ?? parameterField().name"
            [required]="required()" />
    }
    @case (ReportScheduleDialogParameterFieldTypeEnum.DateTimeParameter) {
        <sl-relative-date-input
            [(ngModel)]="value"
            class="w-100"
            [labelKey]="parameterField().promptText ?? parameterField().name"
            [required]="required()" />
    }
    <!-- TODO: Good input for relative time or just normal time picker (time paramteres may not be required to be relative) -->
    @case (ReportScheduleDialogParameterFieldTypeEnum.TimeParameter) {
        <mat-form-field class="w-100">
            <mat-label>{{ parameterField().promptText ?? parameterField().name }}</mat-label>
            <input [(ngModel)]="value" type="text" matInput [required]="required()" />
        </mat-form-field>
    }
    @case (ReportScheduleDialogParameterFieldTypeEnum.StringParameter) {
        <mat-form-field class="w-100">
            <mat-label>{{ parameterField().promptText ?? parameterField().name }}</mat-label>
            <input [(ngModel)]="value" type="text" matInput [required]="required()" />
        </mat-form-field>
    }
    @case (ReportScheduleDialogParameterFieldTypeEnum.DropdownParameter) {
        <mat-form-field class="w-100">
            <mat-label>{{ parameterField().promptText ?? parameterField().name }}</mat-label>
            <mat-select [(ngModel)]="value" [required]="required()">
                <mat-option *ngFor="let option of parameterField().options ?? []" [value]="option.value">
                    {{ option.description }}
                </mat-option>
            </mat-select>
        </mat-form-field>
    }
}
